import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const rootElement = document.getElementById("root");

// Support for react-snap pre-rendering
if (rootElement.hasChildNodes()) {
  // Hydrate pre-rendered HTML
  ReactDOM.hydrateRoot(rootElement, <App />);
} else {
  // Normal React render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
